export enum CustomFormFieldType {
  TEXT = 'TEXT',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
}
